import * as React from 'react';
import {
  Routes,
  Route,
  Link as LinkRoute,
  useNavigate,
  useLocation,
  Navigate,
  Outlet,
} from "react-router-dom";
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListSubheader from '@mui/material/ListSubheader';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import Tooltip from '@mui/material/Tooltip';

import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Home';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ArtTrackSharpIcon from '@mui/icons-material/ArtTrackSharp';
import ImageAspectRatioSharpIcon from '@mui/icons-material/ImageAspectRatioSharp';
import MapSharpIcon from '@mui/icons-material/MapSharp';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PeopleIcon from '@mui/icons-material/People';
import BarChartIcon from '@mui/icons-material/BarChart';
import LayersIcon from '@mui/icons-material/Layers';

import PostAddIcon from '@mui/icons-material/PostAdd';
import SummarizeIcon from '@mui/icons-material/Summarize';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import ViewListIcon from '@mui/icons-material/ViewList';
import SvgIcon from '@mui/material/SvgIcon';

import TwoWheelerIcon from '@mui/icons-material/TwoWheeler';
import BikeScooterTwoToneIcon from '@mui/icons-material/BikeScooterTwoTone';

import useLocalStorageState from 'use-local-storage-state'
import {useAuth} from '../context/AuthContext'

import WarrantyClaim from './components/WarrantyClaim'
import WarrClaims from './components/WarrClaims'

// import {WarrOpsContextProvider} from '../context/WarrOpsContext'

import {
  WarrOpsCodesContextProvider,
  WarrOpsCodesContext, 
  useWarrOpsCodesContext,
  OpCodesItemType,
  OpCodeCategType,
  opscodesDataType,
  WarrOpsCodesResponseType,
  // warrantyoperationsType,
  WarrOpCategoryType,
  WarrOpCategoriesType
} from '../context/WarrOpsCodesContext'

import WarrClaimProvider from '../context/WarrantyClaimContext'

import VehCustInfoProvider from '../context/VehCustInfoContext'
import VehicleCustomerInfo, {newVehicleCustomerInfoPropsExample,viewVehicleCustomerInfoPropsExample,editVehicleCustomerInfoPropsExample, VehicleCustomerInfoProps} from './components/VehicleCustomerInfo'

import theme from '../theme';

const drawerWidth: number = 240;

interface AppBarProps extends MuiAppBarProps {
    open?: boolean;
}
  

// viewBox="0 0 24 24"
//  d="M4.5 12a7.5 7.5 0 0015 0m-15 0a7.5 7.5 0 1115 0m-15 0H3m16.5 0H21m-1.5 0H12m-8.457 3.077l1.41-.513m14.095-5.13l1.41-.513M5.106 17.785l1.15-.964m11.49-9.642l1.149-.964M7.501 19.795l.75-1.3m7.5-12.99l.75-1.3m-6.063 16.658l.26-1.477m2.605-14.772l.26-1.477m0 17.726l-.26-1.477M10.698 4.614l-.26-1.477M16.5 19.794l-.75-1.299M7.5 4.205L12 12m6.894 5.785l-1.149-.964M6.256 7.178l-1.15-.964m15.352 8.864l-1.41-.513M4.954 9.435l-1.41-.514M12.002 12l-3.75 6.495"
// fill="none"
//     strokeWidth={1.5}
//  stroke="currentColor"
function SvgIconWarranty() {
    return (
      <SvgIcon>
        {/* credit: cog icon from https://heroicons.com */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="#000000"
          viewBox="0 0 52 52"
          strokeWidth={1.5}
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M26,2c3,0,5.43,3.29,8.09,4.42s6.82.51,8.84,2.65,1.51,6.07,2.65,8.84S50,23,50,26s-3.29,5.43-4.42,8.09-.51,6.82-2.65,8.84-6.07,1.53-8.84,2.65S29,50,26,50s-5.43-3.29-8.09-4.42-6.82-.51-8.84-2.65-1.53-6.07-2.65-8.84S2,29,2,26s3.29-5.43,4.42-8.09.51-6.82,2.65-8.84,6.07-1.53,8.84-2.65S23,2,26,2Zm0,7.58A16.42,16.42,0,1,0,42.42,26h0A16.47,16.47,0,0,0,26,9.58Zm7.62,9.15,1.61,1.52a1.25,1.25,0,0,1,0,1.51L25.08,33.07a2.07,2.07,0,0,1-1.61.7,2.23,2.23,0,0,1-1.61-.7L16.37,27.6a1,1,0,0,1-.1-1.42l.1-.11L18,24.56a1.1,1.1,0,0,1,1.54-.07l.07.07,3.89,4,8.59-9.8A1.1,1.1,0,0,1,33.62,18.73Z"
          />
        </svg>
      </SvgIcon>
    );
}


const AppBar = styled(MuiAppBar, {
      shouldForwardProp: (prop) => prop !== 'open',
    })<AppBarProps>(({ theme, open }) => ({
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
      }),
}));
const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
      '& .MuiDrawer-paper': {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
        boxSizing: 'border-box',
        ...(!open && {
          overflowX: 'hidden',
          transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          width: theme.spacing(7),
          [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
          },
        }),
      },
    }),
);

const dbact_asgrhome =   {action: 'asgrhome', title:'Εργασίες AsterSales' }
const dbact_asvehinfodocnew =   {action: 'asvehinfodocnew', title:'Καταχώριση Οχήματος' }
const dbact_asvehinfodocs =   {action: 'asvehinfodocs', title:'Οχήματα' }
const dbact_asgrwarrnew =   {action: 'asgrwarr', title:'Καταχώριση Δελτίου Εγγύησης' }
const dbact_asgrwarrdocs =  {action: 'asgrwarrdocs', title:'Τα δελτία εγγύησης'}

function AsHomeContainer(){
    return(<>επιλέξετε εργασίες από το αριστερό μενού</>)
}

function DummyContainer(){
  return(<> under construction </>)
}
export default function AfsDashboard() {
    let navigate = useNavigate();
    let location = useLocation();
    let auth = useAuth();
    // let warrOpsCodesContext = useWarrOpsCodesContext();

    const [open, setOpen] = React.useState(true);
    const toggleDrawer = () => {
      setOpen(!open);
    };
    const [dashbaction, setDashbaction ] = React.useState(dbact_asgrhome)
    React.useEffect( () => {
    },[dashbaction] );
  
    function setDashBAction( dhb:{action:string, title:string} ){
      setDashbaction(dhb)
    }
    return(
        <Box id="boxbefappbar1" sx={{ display: 'flex' }}>
          <CssBaseline />
          <AppBar id="appbar1" position="absolute" open={open}>
            <Toolbar id="toolabr-in-appbar1"
              sx={{
                pr: '24px', // keep right padding when drawer closed
              }}
            >
              <IconButton
                edge="start"
                color="inherit"
                aria-label="open drawer"
                onClick={toggleDrawer}
                sx={{
                  marginRight: '36px',
                  ...(open && { display: 'none' }),
                }}
              >
            <MenuIcon />
              </IconButton>
              <Typography
                component="h1"
                variant="h6"
                color="inherit"
                noWrap
                sx={{ flexGrow: 1 }}
              >
                {dashbaction.title}
              </Typography>

              {/* <CartWidget productsCount={productsCount} navigatetocart={navigateToCart} /> */}
              {/* <IconButton color="inherit">
                <Badge badgeContent={4} color="secondary">
                  <NotificationsIcon />
                </Badge>
              </IconButton> */}

            </Toolbar>
          </AppBar>
          <Drawer variant="permanent" open={open}>
            <Toolbar
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                px: [1],
              }}
            >
              <IconButton onClick={toggleDrawer}>
                AfterSales <ChevronLeftIcon />
              </IconButton>
            </Toolbar>
            <Divider />
            <List component="nav">

              <Tooltip title="Καταχώριση Οχήματος" placement="bottom">
              <ListItemButton onClick={(e)=>{ setDashbaction(dbact_asvehinfodocnew) } }>
                <ListItemIcon>
                  <TwoWheelerIcon />
                </ListItemIcon>
                <ListItemText primary="Καταχώριση Οχήματος" />
              </ListItemButton>
              </Tooltip>

              <Tooltip title="Καταχωρημένα Οχήματα" placement="bottom">
              <ListItemButton onClick={(e)=>{ setDashbaction(dbact_asvehinfodocs) } }>
                <ListItemIcon>
                <BikeScooterTwoToneIcon />
                </ListItemIcon>
                <ListItemText primary="Καταχ/να Οχήματα" />
              </ListItemButton>
              </Tooltip>

              <Tooltip title="Νέο Δελτίο Εγγύησης" placement="bottom">
              <ListItemButton onClick={(e)=>{ setDashbaction(dbact_asgrwarrnew) } }>
                <ListItemIcon>
                  <SvgIconWarranty />
                </ListItemIcon>
                <ListItemText primary="Νέο Δελτίο Εγγύησης" />
              </ListItemButton>
              </Tooltip>

              <Tooltip title="Τα δελτία εγγύησης" placement="bottom">
              <ListItemButton onClick={(e)=>{ setDashbaction(dbact_asgrwarrdocs) } }>
                <ListItemIcon>
                <ViewListIcon />
                </ListItemIcon>
                <ListItemText primary="Τα δελτία εγγύησης" />
              </ListItemButton>
              </Tooltip>
              
              <Divider sx={{ my: 1 }} />

              {/* {secondaryListItems} */}
              <Tooltip title="Αρχή" placement="bottom">
              <ListItemButton onClick={(e)=>{ navigate("/", { replace: true })} }>
              <ListItemIcon>
                <HomeIcon />
              </ListItemIcon>
              <ListItemText primary="Αρχή" />
              </ListItemButton>
              </Tooltip>
  
            </List>
          </Drawer>
         
          <Box component="main"
            sx={{
              backgroundColor: (theme) =>
                theme.palette.mode === 'light'
                  ? theme.palette.grey[100]
                  : theme.palette.grey[900],
              flexGrow: 1,
              height: '100vh',
              overflow: 'auto',
            }}
          >

            <Container id="pr-container" maxWidth="lg" sx={{ mt: 2, mb: 4, ml:0 }}>            
              {{
                'asgrhome': <AsHomeContainer />,
                'asvehinfodocnew': <VehCustInfoProvider><VehicleCustomerInfo {...newVehicleCustomerInfoPropsExample} /></VehCustInfoProvider>,
                'asvehinfodocs': <VehCustInfoProvider><VehicleCustomerInfo {...viewVehicleCustomerInfoPropsExample} /></VehCustInfoProvider>,
                'asgrwarr': <WarrOpsCodesContextProvider><WarrClaimProvider><WarrantyClaim /></WarrClaimProvider></WarrOpsCodesContextProvider>,
                'asgrwarrdocs': <WarrClaims />,
              }[dashbaction.action]}
            
              {/* <Copyright sx={{ pt: 4 }} /> */}  
            </Container>
            
          </Box>
  
        </Box>
    )
}